import angular from "angular";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngTouch from "angular-touch";
import uiSelect from "ui-select";

export default angular.module("directives.platformSelector", [
  ngAnimate,
  ngSanitize,
  ngTouch,
  uiSelect,
])

  .directive("platformSelector", function() {
    return {
      restrict: "AE",
      templateUrl: "platform_selector_directive.html",
      scope: {
        brand: "&",
        platforms: "&",
        selected: "=",
      },
      link: function(scope) {
        var brand = null;

        scope.options = [];

        // Methods

        scope.imgSrc = function(option) {
          var platform = platformByKey(option.key);
          return scope.isActive(option) ? platform.images.active : platform.images.default;
        };

        scope.isActive = function(option) {
          return scope.selected && scope.selected.key === option.key;
        };

        scope.select = function(option) {
          if (option.disabled) return;
          scope.selected = platformByKey(option.key);
        };

        // Listeners

        scope.$watch("brand()", function(newBrand) {
          brand = newBrand || null;
          scope.selected = null;
          updateOptionsStates();
        });

        scope.$watch("platforms()", function(platforms) {
          scope.options = (platforms || []).map(function(platform) {
            return {
              key: platform.key,
              label: platform.label,
              disabled: true,
            };
          });
          updateOptionsStates();
        });

        // Helpers

        function platformByKey(key) {
          return scope.platforms().find(function(platform) {
            return platform.key === key;
          });
        }

        function updateOptionsStates() {
          if (scope.options.length === 0) { return; }

          if (brand) {
            scope.options.forEach(function(option) {
              option.disabled = !brand.platforms.some(function(platform) {
                return platform.identifier === option.key;
              });
            });
          } else {
            scope.options.forEach(function(option) {
              option.disabled = true;
            });
          }
        }
      },
    };
  })
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/directives/platform-selector.js